import { takeEveryApiCall } from 'syft-acp-core/sagas/helpers'

import csatWorkersTypes from './action-types'
import { fetchCsatWorkers } from './api'

export default function* root() {
  yield takeEveryApiCall(csatWorkersTypes.ENTITIES_FETCH_BEGIN, fetchCsatWorkers)
}
